import { css, jsx } from '@emotion/core';
import { useRouter } from 'next/router';
import React from 'react';
import { useSelector } from 'react-redux';

import ChartProfiles from '@/src/profile/ChartProfiles';
import Breadcrumbs from '@/src/shared/components/Breadcrumbs';
import Container from '@/src/shared/components/Container';
import Divider from '@/src/shared/components/Divider';
import Heading from '@/src/shared/components/Heading';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import { colors } from '@/styles';
import request from '@/utils/axios';

const style = {
  section: css`

  `,
  title: css`
    margin-bottom: 24px;
    @media print {
      font-size: 2.6rem;
      line-height: 3.2rem;
    }
  `,
  breadcrumbs: css`
    left: 0;
    right: 0;
    width: 100%;
    z-index: 3;
  `,
  info: css`
    color: ${colors.secondaryGray};
    font-size: 1.6rem;
    margin-bottom: 1.6rem;
  `,
  contactUs: css`
    font-weight: 800;
    color: ${colors.secondaryBlue};
  `,
  divider: css`
    @media print {
      display: none;
    }
  `,
};

function SeniorStaff({ data }) {
  const router = useRouter();
  const { isLoading, isLoggedIn } = useSelector((s) => s.auth);

  const { route } = router;
  const enableBio = true;
  const { PageTitle, Profiles } = data;

  return (
    <Layout>
      <Section halfPad>
        <Container css={[style.breadcrumbs]}>
          <Breadcrumbs theme="dark" />
          <Divider type="red" css={style.divider} />
          <Heading type={1} theme="jumbo" css={[style.title]}>
            {PageTitle}
          </Heading>
          {(!isLoading && !isLoggedIn) ? (
            <div css={style.info}>
              To contact a member of APCIA&apos;s Senior Staff, please use our{' '}
              <a css={style.contactUs} href="/about/contact-us/form">
                {' '}
                Contact Us{' '}
              </a>{' '}
              form.
            </div>
          ) : null}
        </Container>
      </Section>
      <Section halfPad style={{ paddingTop: 0 }}>
        <Container>
          <ChartProfiles profiles={Profiles} route={route} enableBio={enableBio} seniorStaff />
        </Container>
      </Section>
      <WebLogImage title={PageTitle} path="/about/leadership/senior-staff" />
    </Layout>
  );
};

export async function getStaticProps() {
  try {
    const response = await request({
      url: `profile/chartprofiles`,
      method: 'GET',
      params: {
        chartid: 1,
      },
    });
    const { data } = response;

    return { props: { data } };
  } catch (err) {
    return { props: { data: undefined, error: true } };
  }
}

export default SeniorStaff;
